export default {"src":"/_next/static/media/error.3490f9c4.svg","height":165,"width":141,"blurWidth":0,"blurHeight":0};